import classes from "./companyShow.module.css";
import { useTranslation } from "react-i18next";


const PagesDetalis = ({ pages }) => {
  const { t } = useTranslation();

  const titles = {
    id: "#",
    name:t("Name"),
  
  

  };

  const { id, name,  } = pages;

  return (
    <div className={classes.container}>
    
      <div className={classes.tableCard}> 
         
        <table className={classes.showCurrency}>
          <tr>
            <th>{titles.id}</th>
            <td>{id}</td>
          </tr>
          <tr>
            <th>{titles.name}</th>
            <td>{name}</td>
          </tr>

        </table>
      </div>
    </div>
  );
};

export default PagesDetalis;
